module.exports = __webpack_public_path__ + "static/media/Ultra-Regular.1c1155b5.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Ultra-Regular.ttf
// module id = 3808
// module chunks = 70